import { Env } from '../env';
import { ApiClient } from '../http/api_client';
import { CarouselItem } from '../models/item';
import {isClub, isSoloare, SiteType} from '../models/js_env';

const RR_API_KEY = Env.SETTING.rr.apiKey;
const RR_BASE_URL = Env.SETTING.rr.urlBase;
const RR_CLICKTHRU_SERVER = window.location.protocol + "//" + window.location.host;

export class RrRepository {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() { }

  sendRequestToRrServer(rrRequestParam: RrRequestParam, isSoloare?:boolean) {
    if (typeof r3_common === 'undefined') return;

    var R3_COMMON = new r3_common();

    R3_COMMON.setApiKey(RR_API_KEY);
    R3_COMMON.setBaseUrl(RR_BASE_URL);
    R3_COMMON.setClickthruServer(RR_CLICKTHRU_SERVER);

    rrRequestParam.userTracking ? R3_COMMON.setSessionId(rrRequestParam.userTracking) : R3_COMMON.setSessionId('');
    rrRequestParam.isLogin && rrRequestParam.userId ? R3_COMMON.setUserId(rrRequestParam.userId) : R3_COMMON.setUserId('');

    if (rrRequestParam.userSegments) {
      rrRequestParam.userSegments.forEach((segment?: string) => { if (segment) R3_COMMON.addSegment(segment) });
    }

    rrRequestParam.setRrRequestParams(R3_COMMON, rrRequestParam.pageOption, isSoloare);

    rr_flush_onload();

    r3();
  }

  async getRrItemsDetail(catalogItemCodes: string[], isVariation: boolean, siteType: SiteType, llCategoryCode?: string, lCategoryCode?: string): Promise<CarouselItem[]> {
    const siteTypeOrdinal = isClub(siteType) ? "CLUB" : isSoloare(siteType) ? "SOLOARE" : "TRYLION";
    const request = { catalogItemCodeList: catalogItemCodes, isVariation: isVariation, siteType: siteTypeOrdinal, llCategoryCode: llCategoryCode, lCategoryCode: lCategoryCode }
    const rrItemsDetail = await ApiClient.post(Env.SETTING.userPublicApi.urlBase + 'api/attract/recommend/richRelevanceItems/', request)
      .catch(() => [])
    return rrItemsDetail.map((rrItemDetail: any) => {
      return {
        isVariation: rrItemDetail.isVariation,
        isMedical: rrItemDetail.isMedicalItem,
        itemCode: rrItemDetail.isVariation ? rrItemDetail.itemGroupCode : rrItemDetail.catalogItemCode,
        supplierId: "P00001",
        promotionDisplayType: rrItemDetail.promotionDisplayType,
        itemName: rrItemDetail.isVariation ? rrItemDetail.itemGroupName : rrItemDetail.itemNameWebUniq,
        imageUrl: rrItemDetail.l1ImageFileUrl,
        displayUserReview: rrItemDetail.isVariation ? rrItemDetail.groupReviewPoint : rrItemDetail.userReviewPoint,
        userReviewCount: rrItemDetail.isVariation ? rrItemDetail.groupReviewCount : rrItemDetail.userReviewCount,
        salesPriceTaxInclude: rrItemDetail.isVariation ? rrItemDetail.groupMinPrice : rrItemDetail.salesPrice,
      };
    });
  }
}

export interface RrRequestParam {
  isLogin: boolean;
  userId?: string;
  userTracking: string;
  userSegments?: string[];
  setRrRequestParams: Function;
  pageOption: any
}
